(() => {
  const filters = [...document.querySelectorAll('.filter')];
  const cards = [...document.querySelectorAll('.gallery-card')];
  const countLabel = document.getElementById('galleryCount');
  if (!filters.length || !countLabel) return;
  const filter = selected => {
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === selected)));
    let count = 0;
    cards.forEach(card => {
      const show = selected === 'All pieces' || (selected === 'Featured' ? card.dataset.featured === 'true' : card.dataset.category === selected);
      card.hidden = !show;
      if (show) count++;
    });
    countLabel.textContent = `${count} pieces · ${selected}`;
  };
  filters.forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
  filter('Featured');
})();
